/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import React from "react";
import { FileInfo } from "Api";
import { useDexterTheme } from "../../DesignSystem/Theme/ThemeContext";

/** Step 3 of the populate modal: the files that will be added. */
export const ReviewList = ({ files }: { files: FileInfo[] }): JSX.Element => {
  const { currentTheme } = useDexterTheme();
  const divider = `1px solid ${currentTheme.colors.dropdownBorderColor}`;

  return (
    <div>
      <p
        style={{
          margin: `0 0 ${currentTheme.spacing.sm}`,
          fontFamily: currentTheme.fonts.primary,
          fontSize: currentTheme.fontSizes.medium,
          color: currentTheme.colors.defaultTextColor,
        }}
      >
        {files.length} file{files.length === 1 ? "" : "s"} will be added to the
        Mapping.
      </p>
      <div style={{ maxHeight: 300, overflowY: "auto" }}>
        {files.map((file) => (
          <div
            key={file.id}
            title={file.attributes?.name}
            style={{
              padding: `${currentTheme.spacing.md} ${currentTheme.spacing.md}`,
              borderBottom: divider,
              fontFamily: currentTheme.fonts.primary,
              fontSize: currentTheme.fontSizes.medium,
              color: currentTheme.colors.defaultTextColor,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {file.attributes?.name}
          </div>
        ))}
      </div>
    </div>
  );
};
